import { render, staticRenderFns } from "./PageOverlay.vue?vue&type=template&id=23ae4480&scoped=true&"
import script from "./PageOverlay.vue?vue&type=script&lang=js&"
export * from "./PageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PageOverlay.vue?vue&type=style&index=0&id=23ae4480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae4480",
  null
  
)

export default component.exports